import React, { Component } from 'react';
import { reduxForm, Field, reset } from 'redux-form';
import { PopupboxManager, PopupboxContainer } from 'react-popupbox';

import {
  transformErrorResponse,
  transformCustomError,
} from '../../helpers/errors';
import MergePurchasePopup from '../MergePurchasePopup/MergePurchasePopup';
import FormError from '../FormError';
import InputField from '../InputField';
import * as api from '../../api';

class PurchaseMerge extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mergeError: undefined,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.onError = this.onError.bind(this);
  }

  onSuccess(purchase) {
    const { onMergeComplete } = this.props;
    onMergeComplete(purchase.id);
  }

  onError({ response }) {
    const error = transformErrorResponse(response.data);
    this.setState({
      mergeError: error,
    });
  }

  async handleSubmit(event) {
    event.preventDefault();
    const id = event.target[0].value;

    if (!id) {
      return;
    }

    const { purchase, dispatch } = this.props;
    dispatch(reset('purchaseMerge'));

    this.setState({
      mergeError: undefined,
    });

    try {
      const { data } = await api.findPurchase(id);
      if (data.status !== 'overdue') {
        const error = transformCustomError(
          `Purchase status is "${data.status}", must be "overdue".`,
        );
        this.setState({
          mergeError: error,
        });

        return;
      }

      const content = (
        <MergePurchasePopup
          purchase={purchase}
          other={data}
          onSuccess={this.onSuccess}
          onError={this.onError}
        />
      );
      PopupboxManager.open({
        content,
      });
    } catch ({ response }) {
      const error = transformErrorResponse(response.data);
      this.setState({
        mergeError: error,
      });

      return;
    }
  }

  render() {
    const { error } = this.props;
    const { mergeError } = this.state;

    return (
      <form onSubmit={this.handleSubmit} className="mar-b">
        <Field
          className="form-control"
          type="number"
          label="Merge in another purchase"
          name="mergePurchase"
          placeholder="Purchase ID"
          component={InputField}
        />
        {error && <FormError error={error} />}
        {mergeError && <FormError error={mergeError} />}
        <button className="btn btn-danger mar-t" type="submit">
          Find purchase
        </button>
        <PopupboxContainer />
      </form>
    );
  }
}

const validate = (values) => {
  let errors = {};

  if (!values.mergePurchase) {
    errors.mergePurchase = 'Required';
  }

  return errors;
};

export default reduxForm({
  form: 'purchaseMerge',
  validate,
})(PurchaseMerge);
